
/**
* Variable to place all the url's used in whole app
*/
export const env = {
    smartTvBucket: "https://magellantv-smart-tv-assets.s3.amazonaws.com/",
    bucketS3: "https://magellantv-test-cloudfront.s3.amazonaws.com/",
    cloudfrontUrl: "https://images.magellantv.com/",
    devCloudFrontUrl: "https://vewd.magellantv.com/",
    devUpdatingVideo: "http://ec2-18-234-81-233.compute-1.amazonaws.com/update",
    prodUpdatingVideo: "http://ec2-18-234-46-144.compute-1.amazonaws.com/update",
    apiUrl: "https://www.magellantv.com/api/v4",
    linkMagellan: "https://www.magellantv.com/vewd",
    qualityParams: "722x406/",
    qualityTitleImage: "528x297/",
    qualityBigSlider: "1280x720/",
    defaultPlayer : 'vewd'
}

/*export const apiDevKeys = {
    "app": {
        "name": "test_app",
        "key": "P7nKDxpgBtx4k",
        "secret": "xsYEI1kg6tTAUgw1Pstx6z15"
    }
}*/

export const apiDevKeys = {
    "app": {
		"name": "magellantv.com",
		"key": "jZXxl4DZzHND2",
		"secret": "E2Ic1Kz31ppohxMXDXQ9VG4d"
	}
}

export const APP_NAME = "vewdTvApp";

export const urlApiCalls = {
    videos: "/video/",
    series: "/series/",
    seriesepisodes: "/seriesepisode/:idserie/:idepisode",
    playlists: "/playlist/",
    featured: "/featured",
    exploreAll: "/explorelander/",
    categoryItems: "/exploresublander/",
    genres: "/genres/",
    genresItem: "/genres/:id/",
    searchContent: "/searchcontent/",
    signIn: "/signin",
    browseToken: "/fireTvlogin/",
    activationCode: "/devicelinking/regcode?userData=",
    tokenDeviceLinking: "/devicelinking/token",
    statusDeviceLinking: "/devicelinking/status/",
    revoke: "/revoke",
    resumeOnComplete: "/resumeOnComplete",
    resume: "/resume"
};

export const urlRoutes = {
    paywall: "/paywall",
    login: "/login",
    featured: "/featured",
    series: '/series/:id',
    videos: '/video/:id',
    playlist: '/playlist/:id',
    explore: "/explore",
    search: "/search",
    deviceSignUp: "/device-link-sign-up",
    deviceSignIn: "/device-link-sign-in",
    tryfree: "/device-link-sign-up",
    settings: "/settings",
    genres: "/genres",
    exitScreen: "/exit-screen",
    videoPlayer: "/videoplayer"
}

export const keyCode = {
    left: window.VK_LEFT || 37,
    right: window.VK_RIGHT || 39,
    enter: window.VK_ENTER || 13,
    up: window.VK_UP || 38,
    down: window.VK_DOWN || 40,
    back: window.VK_BACK || 8,
    backAlt: window.VK_BACK || 461,
    escape: window.VK_ESCAPE || 27,
    play: window.VK_PLAY || 415, // used on vewd
    pause: window.VK_PAUSE || 19, 
    rewind: window.VK_REWIND || 412, // used on vewd
    fastForward: window.VK_FAST_FWD || 417, // used on vewd
    menu: window.VK_INFO || 462, // used on vewd
    stop: window.VK_STOP || 413,
}

export const genresConf = {
    itemWidth: 369
}
